module.exports = __webpack_public_path__ + "static/img/hanguan.808262e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hanguan.png
// module id = T0Kp
// module chunks = 1